export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";